import React from 'react';
import type { LookupAbbreviationWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: LookupAbbreviationWidgetData;
}

export const LookupAbbreviationWidget: React.FC<Props> = ({ data }) => {
  if (data.results.length === 0) return null;

  return (
    <div className="mt-1.5 space-y-1">
      <p className="text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500 font-medium">
        {data.results.length} abbreviation{data.results.length !== 1 ? 's' : ''}
      </p>
      <div className="space-y-1">
        {data.results.map((a) => (
          <div
            key={a.abbreviation}
            className="flex items-center gap-2 text-[11px] bg-violet-50/70 dark:bg-violet-900/10 rounded px-2 py-1.5"
          >
            <span className="font-mono font-bold text-violet-700 dark:text-violet-300 whitespace-nowrap">
              {a.abbreviation}
            </span>
            <span className="text-violet-600 dark:text-violet-400 flex-1 min-w-0 truncate">
              {a.expansion}
            </span>
            <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-violet-100 dark:bg-violet-900/30 text-violet-500 dark:text-violet-400 whitespace-nowrap">
              {a.category}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
